import { ICommentDto, IUser } from "@kuika/kuika-cl-model";
import { IComments } from "../../../../models/interface/comment";

// Stable thread identity: prefer threadId (free-placement / multi-pin-per-component)
// and fall back to kuikaId (the real backend path, one thread per component).
export function threadKey(t: IComments): string {
  return t.threadId ?? t.kuikaId;
}

export enum CommentFilter {
  All = "all",
  Open = "open",
  Resolved = "resolved",
  Mentions = "mentions"
}

export enum CommentSort {
  Newest = "newest",
  Oldest = "oldest"
}

export enum NewCommentScope {
  Page = "page",
  Component = "component"
}

export interface ICommentsPanelProps {}

export interface ICommentsPanelState {
  threads: IComments[];
  allComments: ICommentDto[];
  isLoading: boolean;
  hasError: boolean;
  filter: CommentFilter;
  query: string;
  sort: CommentSort;
  selectedThreadId: string;
  draftNew: string;
  newScope: NewCommentScope;
  replyingThreadId: string;
  draftReply: string;
  editingCommentId: string;
  draftEdit: string;
  openMenuCommentId: string;
  expandedThreadIds: string[];
  pendingAttachmentUrl: string;
  pendingAttachmentName: string;
}

// Viewport-fixed position for a portaled popup (emoji picker).
export interface IPopupPosition {
  top: number;
  left: number;
}

// Viewport-fixed box (canvas hover highlight). Portaled overlays are `position: fixed`, so these are
// window coordinates, not document ones.
export interface IViewportBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

// The visible edges an overlay must stay inside — the canvas iframe's on-screen rect.
export interface IVisibleBounds {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

// Slack-style "who reacted" hover tooltip (portaled, positioned above the hovered pill).
export interface IReactionTip {
  names: string[];
  emoji: string;
  top: number;
  left: number;
}

export interface IThreadViewModel {
  thread: IComments;
  root: ICommentDto;
  replies: ICommentDto[];
  order: number;
  isResolved: boolean;
  anchorLabel: string;
  isDeleted: boolean;
  componentName: string;
}

export interface IReactionGroup {
  emoji: string;
  count: number;
  reactedByCurrentUser: boolean;
}

export interface IResolvedByInfo {
  user: IUser;
  at: Date;
}

export interface IFilterCounts {
  all: number;
  open: number;
  resolved: number;
  mentions: number;
}
